/* ==========================================================================
   Mix & Match — livraison offerte + upsell (pages produit des duos et panier)

   - Barres « Plus que X € pour la livraison offerte » ([data-mm-ship]) :
     mises à jour en direct depuis le vrai panier Shopify (cart.total_price,
     remises comprises) à chaque cartUpdate du thème.
   - Ajouts « sans recharger » ([data-mm-add], [data-mm-pack]) via l'Ajax
     Cart API, puis publication de cartUpdate avec les sections du thème :
     le panier latéral, le compteur et les barres se mettent à jour d'un coup.
   - Suivi : chaque ligne ajoutée porte _source (pdp_upsell, pdp_pack,
     drawer_upsell) ; un événement dataLayer « mm_upsell_add » (nom dédié,
     pour ne pas doubler l'add_to_cart déjà remonté par Shopify / Meta CAPI).
   ========================================================================== */
(function () {
  'use strict';
  if (window.MMUpsell) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function moneyFormat() {
    var el = document.querySelector('[data-money-format]');
    return el ? el.getAttribute('data-money-format') : '';
  }

  function formatMoney(cents) {
    var format = moneyFormat();
    var match = format && format.match(/\{\{\s*(\w+)\s*\}\}/);
    var parts = (cents / 100).toFixed(2).split('.');
    var sep = function (t, d) {
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t) + d + parts[1];
    };
    if (!match) return sep('.', ',') + ' €';
    var amount = match[1] === 'amount_with_comma_separator' ? sep('.', ',') : sep(',', '.');
    return format.replace(match[0], amount);
  }

  /* ---------------------------------------------------------------- */
  /* Barres de livraison offerte                                       */
  /* ---------------------------------------------------------------- */

  function updateBars(total) {
    document.querySelectorAll('[data-mm-ship]').forEach(function (bar) {
      var threshold = Number(bar.getAttribute('data-threshold') || 0);
      if (!threshold) return;
      var text = bar.querySelector('[data-mm-ship-text]');
      var fill = bar.querySelector('[data-mm-ship-fill]');
      var done = total >= threshold;
      var pct = Math.max(0, Math.min(100, Math.round((total / threshold) * 100)));
      bar.classList.toggle('is-done', done);
      if (fill) fill.style.width = pct + '%';
      if (!text) return;
      if (done) {
        text.textContent = bar.getAttribute('data-done');
      } else if (total <= 0) {
        text.textContent = bar.getAttribute('data-empty');
      } else {
        text.textContent = bar.getAttribute('data-remaining').replace('[montant]', formatMoney(threshold - total));
      }
    });
    updatePacks(total);
  }

  /* ---------------------------------------------------------------- */
  /* Sélection complète (duo + 4 sauces) sur la page produit           */
  /* ---------------------------------------------------------------- */

  var duoVariant = null;
  var lastTotal = 0;
  var lastCart = null;

  function cartHasVariant(id) {
    if (!lastCart || !id) return false;
    return (lastCart.items || []).some(function (i) {
      return String(i.variant_id || i.id) === String(id);
    });
  }

  function currentDuoId(pack) {
    if (duoVariant) return duoVariant.id;
    var input = document.querySelector('product-form form input[name="id"], form[action*="/cart/add"] input[name="id"]');
    return input && input.value ? input.value : pack.getAttribute('data-duo-id');
  }

  /* « 2 sauces seules : 8,99 € + 14,99 € de frais de livraison = ~~23,98 €~~ » */
  function fillCompare(el, template, base, shipping) {
    el.textContent = '';
    var parts = template
      .replace('[duo]', formatMoney(base))
      .replace('[livraison]', formatMoney(shipping))
      .split('[total]');
    el.appendChild(document.createTextNode(parts[0]));
    if (parts.length > 1) {
      var s = document.createElement('s');
      s.textContent = formatMoney(base + shipping);
      el.appendChild(s);
      el.appendChild(document.createTextNode(parts[1]));
    }
  }

  var MAX_AUTO = 2;

  function packReached(pack) {
    var duoPrice = duoVariant ? duoVariant.price : Number(pack.getAttribute('data-duo-price') || 0);
    var withDuo = !cartHasVariant(currentDuoId(pack));
    var sum = lastTotal + (withDuo ? duoPrice : 0);
    pack.querySelectorAll('[data-mm-pack-item]').forEach(function (item) {
      sum += Number(item.getAttribute('data-price') || 0);
    });
    return { sum: sum, ok: sum >= Number(pack.getAttribute('data-threshold') || 0) };
  }

  function nextSauce(pack) {
    var data = popData();
    if (!data || !data.options) return null;
    var used = [];
    pack.querySelectorAll('[data-mm-pack-item]').forEach(function (item) {
      used.push(String(item.getAttribute('data-variant-id')));
    });
    var inCart = lastCart
      ? lastCart.items.map(function (i) {
          return String(i.product_id);
        })
      : [];
    var featured = data.featured || [];
    var pool = data.options.filter(function (o) {
      /* pas de doublon avec le pack, le panier ou les sauces du duo */
      return used.indexOf(String(o.id)) === -1 && inCart.indexOf(String(o.pid)) === -1 && !/alg[ée]rienne|barbecue/i.test(o.name);
    });
    pool.sort(function (a, b) {
      var ia = featured.indexOf(String(a.pid));
      var ib = featured.indexOf(String(b.pid));
      return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib);
    });
    return pool[0] || null;
  }

  /* Fiche produit : une sauce de plus si le pack n'atteint pas le seuil
     (duo 500 ml, sauce remplacée par une moins chère…), retirée dès
     qu'elle n'est plus nécessaire. */
  function balancePack(pack) {
    if (pack.hasAttribute('data-base')) return;
    var data = popData();
    if (!data) return;
    for (var guard = 0; guard < MAX_AUTO + 1; guard++) {
      var autos = pack.querySelectorAll('[data-mm-auto]');
      var state = packReached(pack);
      if (!state.ok && autos.length < MAX_AUTO) {
        var sauce = nextSauce(pack);
        if (!sauce) return;
        var holder = document.createElement('div');
        holder.innerHTML = tileHtml(sauce, data);
        var tile = holder.querySelector('[data-mm-pack-item]');
        tile.setAttribute('data-mm-auto', '');
        tile.classList.add('is-swapped');
        var tiles = pack.querySelector('.mm-pack__tiles');
        while (holder.firstChild) tiles.appendChild(holder.firstChild);
        continue;
      }
      if (state.ok && autos.length) {
        var last = autos[autos.length - 1];
        var price = Number(last.getAttribute('data-price') || 0);
        if (state.sum - price >= Number(pack.getAttribute('data-threshold') || 0)) {
          var plus = last.previousElementSibling;
          if (plus && plus.classList.contains('mm-plus')) plus.remove();
          last.remove();
          continue;
        }
      }
      return;
    }
  }

  /* Recalcule chaque pack d'après le vrai panier :
     - fiche produit : duo + sauces, ou sauces seules si ce duo est déjà au panier
     - popup : sauces seules (data-base = total du panier au moment de l'ajout) */
  function updatePacks(total) {
    if (typeof total === 'number') lastTotal = total;
    document.querySelectorAll('[data-mm-pack]').forEach(function (pack) {
      balancePack(pack);
      var isPop = pack.hasAttribute('data-base');
      var duoPrice = duoVariant ? duoVariant.price : Number(pack.getAttribute('data-duo-price') || 0);
      var duoInCart = !isPop && cartHasVariant(currentDuoId(pack));
      var withDuo = !isPop && !duoInCart;
      pack.classList.toggle('is-duo-in-cart', duoInCart);

      var sauces = 0;
      var items = pack.querySelectorAll('[data-mm-pack-item]');
      items.forEach(function (item) {
        sauces += Number(item.getAttribute('data-price') || 0);
      });
      var count = String(items.length);
      var current = isPop ? Number(pack.getAttribute('data-base')) : lastTotal; /* panier avant ajout */
      var adding = sauces + (withDuo ? duoPrice : 0); /* ce que le bouton ajoute */
      var threshold = Number(pack.getAttribute('data-threshold') || 0);
      var shipping = Number(pack.getAttribute('data-shipping') || 0);
      var finalTotal = current + adding;
      var reached = finalTotal >= threshold;
      /* sans les sauces, la livraison serait-elle payante ? */
      var withoutSauces = current + (withDuo ? duoPrice : 0);
      var savesShipping = shipping > 0 && reached && withoutSauces < threshold;
      var compareBase = withDuo && current === 0 ? duoPrice : withoutSauces;
      var diff = sauces - shipping;

      var duoEl = pack.querySelector('[data-mm-pack-duo]');
      if (duoEl) duoEl.textContent = duoInCart ? pack.getAttribute('data-in-cart') || '✓' : formatMoney(isPop ? current : duoPrice);
      var totalEl = pack.querySelector('[data-mm-pack-total]');
      if (totalEl) totalEl.textContent = formatMoney(adding);

      var savedEl = pack.querySelector('[data-mm-pack-saved]');
      if (savedEl) {
        savedEl.hidden = !savesShipping;
        savedEl.textContent = (pack.getAttribute('data-saved') || '').replace('[livraison]', formatMoney(shipping));
      }

      var compareEl = pack.querySelector('[data-mm-pack-compare]');
      if (compareEl) {
        var compareTpl = withDuo && current === 0 ? pack.getAttribute('data-compare') : pack.getAttribute('data-compare-cart') || pack.getAttribute('data-compare');
        compareEl.hidden = !(shipping > 0 && withoutSauces < threshold);
        if (!compareEl.hidden) fillCompare(compareEl, compareTpl || '', compareBase, shipping);
      }

      var plusEl = pack.querySelector('[data-mm-pack-plus]');
      if (plusEl) {
        var plusText = diff > 0 ? pack.getAttribute('data-plus') : pack.getAttribute('data-plus-cheaper');
        var showPlus = savesShipping && plusText;
        plusEl.hidden = !showPlus;
        if (showPlus) plusEl.textContent = plusText.replace('[diff]', formatMoney(diff)).replace('[n]', count);
      }

      var statusEl = pack.querySelector('[data-mm-pack-status]');
      if (statusEl) {
        statusEl.hidden = reached;
        if (!reached) {
          statusEl.textContent = pack.getAttribute('data-missing').replace('[montant]', formatMoney(threshold - finalTotal));
        }
      }

      var ribbon = pack.querySelector('[data-mm-pack-ribbon]');
      if (ribbon) ribbon.hidden = !reached;
      pack.classList.toggle('is-free', reached);

      var cta = pack.querySelector('[data-mm-pack-cta]');
      var btn = pack.querySelector('[data-mm-pack-add]');
      var ctaTpl = withDuo ? pack.getAttribute('data-cta') : pack.getAttribute('data-cta-cart') || pack.getAttribute('data-cta');
      var totalSauces = String(items.length + (isPop ? 0 : 2));
      var ctaText = (ctaTpl || '').replace('[prix]', formatMoney(adding)).replace('[n]', count).replace('[t]', totalSauces);
      var tilesEl = pack.querySelector('.mm-pack__tiles');
      if (tilesEl && !isPop) tilesEl.style.setProperty('--mm-cols', items.length > 4 ? 3 : 4);
      var headEl = pack.querySelector('[data-mm-pack-headline]');
      if (headEl) headEl.textContent = headEl.getAttribute('data-tpl').replace('[t]', totalSauces);
      if (btn) btn.dataset.label = ctaText;
      if (cta && btn && !btn.classList.contains('is-busy') && !btn.classList.contains('is-added')) cta.textContent = ctaText;
    });
  }

  /* ---------------------------------------------------------------- */
  /* Produits déjà dans le panier : signalés (page produit)             */
  /* ---------------------------------------------------------------- */

  function markInCart(cart) {
    var ids = (cart.items || []).map(function (i) {
      return String(i.product_id);
    });
    document.querySelectorAll('[data-mm-item]').forEach(function (item) {
      item.classList.toggle('is-in-cart', ids.indexOf(item.getAttribute('data-product-id')) !== -1);
    });
  }

  /* ---------------------------------------------------------------- */
  /* Ajout au panier (Ajax Cart API) + rafraîchissement du thème        */
  /* ---------------------------------------------------------------- */

  function track(items, source) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'mm_upsell_add',
      mm_source: source,
      mm_items: items.map(function (i) {
        return { variant_id: i.id, quantity: i.quantity, title: i.title || '' };
      })
    });
  }

  /* Suivi des commandes : attributs de panier, visibles dans la commande
     Shopify (Informations supplémentaires), comme l'attribut « Mix & Match »
     du diaporama / de la section. Ne bloque jamais l'ajout au panier. */
  var SOURCE_LABELS = {
    pdp_pack: 'Pack fiche produit',
    popup_pack: 'Popup après ajout du duo',
    pdp_upsell: 'fiche produit',
    drawer_upsell: 'panier latéral'
  };

  function pageLabel() {
    var path = window.location.pathname;
    if (path.indexOf('/collections/') !== -1) return 'collection';
    if (path.indexOf('/products/') !== -1) return 'fiche produit';
    return 'accueil';
  }

  /* « SAUCE SAMOURAÏ » → « Samouraï », « MIX & MATCH ALGÉRIENNE / BARBECUE » → « Duo Algérienne / Barbecue » */
  function shortName(title) {
    var name = String(title || '')
      .replace(/^SAUCE\s+|\s+SAUCE$/gi, '')
      .replace(/^MIX\s*&(amp;)?\s*MATCH\s*/i, 'Duo ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
    return name.replace(/(^|[\s/(-])(\S)/g, function (m, sep, ch) {
      return sep + ch.toUpperCase();
    });
  }

  function tagCart(added, source) {
    if (!added || !added.length || !SOURCE_LABELS[source]) return Promise.resolve();
    var attrs = {};
    var amount = 0;
    var names = added.map(function (i) {
      amount += (i.final_line_price || i.price * i.quantity || 0);
      var fmt = /950/.test(i.variant_title || '') ? ' 950' : /500/.test(i.variant_title || '') ? ' 500' : '';
      return shortName(i.product_title || i.title) + fmt + (i.quantity > 1 ? ' ×' + i.quantity : '');
    });
    if (source === 'pdp_pack' || source === 'popup_pack') {
      var where = source === 'popup_pack' ? SOURCE_LABELS[source] + ' (' + pageLabel() + ')' : SOURCE_LABELS[source];
      attrs['Upsell pack'] = where + ' · ' + formatMoney(amount) + ' · ' + names.join(', ');
    } else {
      var previous = (lastCart && lastCart.attributes && lastCart.attributes['Upsell à l’unité']) || '';
      var entry = names.join(', ') + ' (' + SOURCE_LABELS[source] + ')';
      attrs['Upsell à l’unité'] = previous ? previous + ' | ' + entry : entry;
    }
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
  }

  function addToCart(items, source, openDrawer) {
    var sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } })
    );
    var payload = items.map(function (i) {
      return { id: Number(i.id), quantity: i.quantity || 1, properties: { _source: source } };
    });
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: payload, sections: sections, sections_url: window.location.pathname })
    })
      .then(function (res) {
        return res.json().then(function (state) {
          if (!res.ok || state.status) throw new Error(state.description || state.message || 'error');
          return state;
        });
      })
      .then(function (state) {
        track(items, source);
        return tagCart(state.items || [state], source).then(function () {
          return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            cart.sections = state.sections;
            if (window.theme && window.theme.pubsub) {
              window.theme.pubsub.publish(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'mm-upsell', cart: cart });
            } else {
              syncCart(cart);
            }
            if (openDrawer) {
              var drawer = document.querySelector('cart-drawer');
              if (drawer && typeof drawer.show === 'function') drawer.show();
            }
            return cart;
          });
      });
  }

  function setBusy(button, state) {
    var label = button.querySelector('[data-mm-label]') || button;
    if (!button.dataset.label) button.dataset.label = label.textContent;
    button.disabled = state === 'busy';
    button.classList.toggle('is-busy', state === 'busy');
    button.classList.toggle('is-added', state === 'added');
    if (state === 'busy') label.textContent = button.getAttribute('data-busy') || '…';
    else if (state === 'added') label.textContent = button.getAttribute('data-added') || '✓';
    else if (state === 'error') label.textContent = button.getAttribute('data-error') || '!';
    else label.textContent = button.dataset.label;
    if (state === 'added' || state === 'error') {
      setTimeout(function () {
        setBusy(button, 'idle');
      }, 1800);
    }
  }

  /* Format 500 / 950 d'une carte sauce */
  document.addEventListener('click', function (event) {
    var fmt = event.target.closest && event.target.closest('[data-mm-format]');
    if (fmt) {
      var item = fmt.closest('[data-mm-item]');
      item.querySelectorAll('[data-mm-format]').forEach(function (b) {
        var on = b === fmt;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var add = item.querySelector('[data-mm-add]');
      add.setAttribute('data-variant-id', fmt.getAttribute('data-variant-id'));
      var price = item.querySelector('[data-mm-price]');
      if (price) price.textContent = formatMoney(Number(fmt.getAttribute('data-price')));
      var img = item.querySelector('[data-mm-img]');
      var src = fmt.getAttribute('data-img');
      if (img && src) {
        img.removeAttribute('srcset');
        img.src = src;
      }
      return;
    }

    var addBtn = event.target.closest && event.target.closest('[data-mm-add]');
    if (addBtn) {
      event.preventDefault();
      setBusy(addBtn, 'busy');
      addToCart(
        [{ id: addBtn.getAttribute('data-variant-id'), quantity: 1, title: addBtn.getAttribute('data-title') }],
        addBtn.getAttribute('data-source') || 'pdp_upsell',
        false
      )
        .then(function () {
          setBusy(addBtn, 'added');
        })
        .catch(function () {
          setBusy(addBtn, 'error');
        });
      return;
    }

    var packBtn = event.target.closest && event.target.closest('[data-mm-pack-add]');
    if (packBtn) {
      event.preventDefault();
      var pack = packBtn.closest('[data-mm-pack]');
      var inPop = pack.hasAttribute('data-base');
      var items = [];
      var duoId = currentDuoId(pack);
      if (duoId && !inPop && !cartHasVariant(duoId)) items.push({ id: duoId, quantity: 1, title: pack.getAttribute('data-duo-title') });
      pack.querySelectorAll('[data-mm-pack-item]').forEach(function (item) {
        items.push({ id: item.getAttribute('data-variant-id'), quantity: 1, title: item.getAttribute('data-title') });
      });
      setBusy(packBtn, 'busy');
      addToCart(items, inPop ? 'popup_pack' : 'pdp_pack', !inPop)
        .then(function () {
          setBusy(packBtn, 'added');
          if (inPop) {
            setTimeout(function () {
              closePopup('added');
            }, 700);
          }
        })
        .catch(function () {
          setBusy(packBtn, 'error');
        });
    }
  });

  /* Panier : sauces à l'unité → duo Mix & Match. On ajoute d'abord le duo
     (si ça échoue, rien n'est retiré), puis on retire les sauces et on
     note le passage en duo dans la commande. */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-mm-duo-switch]');
    if (!btn) return;
    event.preventDefault();
    setBusy(btn, 'busy');
    var updates = {};
    (btn.getAttribute('data-remove') || '').split(',').forEach(function (pair) {
      var i = pair.lastIndexOf(':');
      if (i > 0) updates[pair.slice(0, i)] = Number(pair.slice(i + 1));
    });
    var sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } })
    );
    var json = { 'Content-Type': 'application/json', Accept: 'application/json' };
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: json,
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-variant-id')), quantity: 1, properties: { _source: 'cart_duo_switch' } }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add');
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: json,
          body: JSON.stringify({
            updates: updates,
            attributes: { 'Passage en duo': btn.getAttribute('data-track') + ' (panier)' },
            sections: sections,
            sections_url: window.location.pathname
          })
        });
      })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        track([{ id: btn.getAttribute('data-variant-id'), quantity: 1, title: btn.getAttribute('data-track') }], 'cart_duo_switch');
        if (window.theme && window.theme.pubsub) {
          window.theme.pubsub.publish(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'mm-upsell', cart: cart });
        } else {
          syncCart(cart);
        }
      })
      .catch(function () {
        setBusy(btn, 'error');
      });
  });

  /* Sélection complète : une sauce remplacée par une autre */
  document.addEventListener('change', function (event) {
    var select = event.target.closest && event.target.closest('[data-mm-pack-select]');
    if (!select) return;
    var line = select.closest('[data-mm-pack-item]');
    var opt = select.options[select.selectedIndex];
    line.setAttribute('data-variant-id', opt.value);
    line.setAttribute('data-price', opt.getAttribute('data-price'));
    line.setAttribute('data-title', opt.getAttribute('data-name'));
    var price = line.querySelector('[data-mm-pack-price]');
    if (price) price.textContent = formatMoney(Number(opt.getAttribute('data-price')));
    var name = line.querySelector('[data-mm-pack-name]');
    if (name) name.textContent = opt.getAttribute('data-name');
    var img = line.querySelector('[data-mm-pack-img]');
    var src = opt.getAttribute('data-img');
    if (img && src) {
      img.removeAttribute('srcset');
      img.src = src;
      img.alt = opt.getAttribute('data-name');
    }
    line.classList.remove('is-swapped');
    void line.offsetWidth;
    line.classList.add('is-swapped');
    updatePacks();
  });


  /* ---------------------------------------------------------------- */
  /* Popup après l'ajout d'un duo Mix & Match                          */
  /* Le nombre de sauces proposées dépend du vrai panier : on prend    */
  /* le minimum pour atteindre le seuil (1 duo 950 → 4, 2 duos → 3…).  */
  /* ---------------------------------------------------------------- */

  var MAX_SAUCES = 6;
  var popup = null;
  var lastFocus = null;

  function popData() {
    var el = document.getElementById('mm-pop-data');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function pickSauces(data, cart) {
    var inCart = (cart.items || []).map(function (i) {
      return String(i.product_id);
    });
    var featured = data.featured || [];
    var pool = data.options.filter(function (o) {
      return inCart.indexOf(String(o.pid)) === -1;
    });
    /* nos 4 meilleures ventes d'abord, puis le reste de la collection */
    pool.sort(function (a, b) {
      var ia = featured.indexOf(String(a.pid));
      var ib = featured.indexOf(String(b.pid));
      return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib);
    });
    var remaining = data.threshold - cart.total_price;
    var picked = [];
    var sum = 0;
    for (var i = 0; i < pool.length && sum < remaining && picked.length < MAX_SAUCES; i++) {
      picked.push(pool[i]);
      sum += pool[i].price;
    }
    return picked;
  }

  function tileHtml(sauce, data) {
    var t = data.t;
    var opts = data.options
      .map(function (o) {
        return (
          '<option value="' + esc(o.id) + '" data-price="' + esc(o.price) + '" data-name="' + esc(o.name) +
          '" data-img="' + esc(o.img) + '"' + (String(o.id) === String(sauce.id) ? ' selected' : '') + '>' +
          esc(o.name) + ' · 950 ml</option>'
        );
      })
      .join('');
    return (
      '<span class="mm-plus" aria-hidden="true">+</span>' +
      '<div class="mm-tile" data-mm-pack-item data-variant-id="' + esc(sauce.id) + '" data-price="' + esc(sauce.price) +
      '" data-title="' + esc(sauce.name) + '">' +
      '<span class="mm-tile__img"><img src="' + esc(sauce.img) + '" alt="' + esc(sauce.name) + '" loading="lazy" data-mm-pack-img></span>' +
      '<span class="mm-tile__name" data-mm-pack-name>' + esc(sauce.name) + '</span>' +
      '<span class="mm-tile__price" data-mm-pack-price>' + esc(formatMoney(sauce.price)) + '</span>' +
      '<label class="mm-tile__swap"><span aria-hidden="true">↻ ' + esc(t.pack_swap) + '</span>' +
      '<span class="mm-pack__sr">' + esc(t.pack_change) + ' (' + esc(sauce.name) + ')</span>' +
      '<select class="mm-tile__select" data-mm-pack-select>' + opts + '</select></label>' +
      '</div>'
    );
  }

  /* Pendant le popup, le panier latéral reste fermé (un seul calque à
     l'écran, surtout sur mobile) : son show() est neutralisé, puis rendu. */
  function holdDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.mmHeld) return;
    drawer.mmHeld = true;
    drawer.show = function () {
      return Promise.resolve();
    };
    if (drawer.open && typeof drawer.hide === 'function') drawer.hide();
  }

  function releaseDrawer(openIt) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    if (drawer.mmHeld) {
      delete drawer.show; /* retour à la méthode du thème */
      drawer.mmHeld = false;
    }
    if (openIt && typeof drawer.show === 'function') drawer.show();
  }

  /* reason : 'skip' (voir mon panier) ou 'added' → ouvre le panier latéral */
  function closePopup(reason) {
    if (!popup) return;
    var el = popup;
    popup = null;
    el.classList.remove('is-open');
    document.documentElement.classList.remove('mm-pop-lock');
    document.removeEventListener('keydown', onPopKey);
    setTimeout(function () {
      el.remove();
    }, 250);
    var openIt = reason === 'skip' || reason === 'added';
    releaseDrawer(openIt);
    if (!openIt && lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
  }

  function onPopKey(event) {
    if (event.key === 'Escape') closePopup();
  }

  function openPopup(cart, bundleItem) {
    var data = popData();
    if (!data || !data.options || cart.total_price >= data.threshold) return;
    var sauces = pickSauces(data, cart);
    if (!sauces.length) return;
    /* jamais deux popups à la fois (ex. popup « packs » déjà ouvert) */
    if (document.querySelector('mix-match-packs-upsell.is-open')) return;
    if (popup) popup.remove();

    var t = data.t;
    var one = sauces.length === 1;
    var n = String(sauces.length);
    var img = bundleItem && (bundleItem.image || (bundleItem.featured_image && bundleItem.featured_image.url));
    if (!img) {
      (cart.items || []).forEach(function (i) {
        if (!img && String(i.product_id) === String(bundleItem.product_id)) img = i.image;
      });
    }
    if (img) img = img + (img.indexOf('?') === -1 ? '?' : '&') + 'width=240';

    var wrap = document.createElement('div');
    wrap.className = 'mm-pop';
    wrap.innerHTML =
      '<div class="mm-pop__backdrop" data-mm-pop-close></div>' +
      '<div class="mm-pop__panel" role="dialog" aria-modal="true" aria-labelledby="mm-pop-title">' +
      '<button type="button" class="mm-pop__x" data-mm-pop-close aria-label="' + esc(t.pop_close) + '">×</button>' +
      '<p class="mm-pop__added">' + esc(t.pop_added) + '</p>' +
      '<div class="mm-pack mm-pack--pop" data-mm-pack' +
      ' data-base="' + esc(cart.total_price) + '"' +
      ' data-threshold="' + esc(data.threshold) + '"' +
      ' data-shipping="' + esc(data.shipping) + '"' +
      ' data-missing="' + esc(t.pack_missing) + '"' +
      ' data-compare="' + esc(t.pop_compare) + '"' +
      ' data-plus="' + esc(one ? t.pop_plus_1 : t.pop_plus) + '"' +
      ' data-plus-cheaper="' + esc(one ? t.pop_cheaper_1 : t.pop_cheaper) + '"' +
      ' data-cta="' + esc(one ? t.pop_cta_1 : t.pop_cta) + '"' +
      ' data-saved="' + esc(t.pack_saved) + '">' +
      '<span class="mm-pack__ribbon" data-mm-pack-ribbon>🚚 ' + esc(t.pack_badge) + '</span>' +
      '<div class="mm-pack__head">' +
      '<img class="mm-pack__logo" src="' + esc(data.logo) + '" width="344" height="197" alt="">' +
      '<div><p class="mm-pack__kicker">' + esc(t.pack_kicker) + '</p>' +
      '<p class="mm-pack__headline" id="mm-pop-title">' + esc((one ? t.pop_headline_1 : t.pop_headline).replace('[n]', n)) + '</p></div>' +
      '</div>' +
      '<div class="mm-pack__tiles" style="--mm-cols:' + (sauces.length <= 4 ? sauces.length : 3) + '">' +
      '<div class="mm-tile mm-tile--duo">' +
      '<span class="mm-tile__img">' + (img ? '<img src="' + esc(img) + '" alt="">' : '') + '</span>' +
      '<span class="mm-tile__name">' + esc(t.pop_cart) + '</span>' +
      '<span class="mm-tile__price" data-mm-pack-duo></span>' +
      '</div>' +
      sauces.map(function (s) {
        return tileHtml(s, data);
      }).join('') +
      '</div>' +
      '<div class="mm-pack__deal">' +
      '<p class="mm-pack__saved" data-mm-pack-saved hidden></p>' +
      '<p class="mm-pack__compare" data-mm-pack-compare></p>' +
      '<p class="mm-pack__plus" data-mm-pack-plus></p>' +
      '<p class="mm-pack__status" data-mm-pack-status></p>' +
      '</div>' +
      '<button type="button" class="mm-pack__cta" data-mm-pack-add data-busy="' + esc(t.busy) + '" data-added="' + esc(t.added) +
      '" data-error="' + esc(t.error) + '"><span data-mm-label data-mm-pack-cta></span></button>' +
      '</div>' +
      '<button type="button" class="mm-pop__skip" data-mm-pop-close="skip">' + esc(t.pop_skip) + '</button>' +
      '</div>';

    document.body.appendChild(wrap);
    document.documentElement.classList.add('mm-pop-lock');
    popup = wrap;
    lastFocus = document.activeElement;
    updatePacks();
    document.addEventListener('keydown', onPopKey);
    void wrap.offsetWidth; /* force le reflow pour que la transition joue */
    wrap.classList.add('is-open');
    var cta = wrap.querySelector('[data-mm-pack-add]');
    if (cta) cta.focus({ preventScroll: true });

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'mm_popup_view', mm_sauces: sauces.length, mm_cart_total: cart.total_price / 100 });
  }

  document.addEventListener('click', function (event) {
    /* Clic n'importe où = fermeture, sauf sur un élément actif
       (bouton d'ajout, « Changer ») pour ne pas fermer par erreur. */
    if (!popup || !event.target.closest) return;
    var closer = event.target.closest('[data-mm-pop-close]');
    if (closer) return closePopup(closer.getAttribute('data-mm-pop-close'));
    if (!popup.contains(event.target) || !event.target.closest('button, select, label, a, input')) closePopup();
  });

  /* Tous les ajouts du thème (fiche produit, section Mix & Match, story)
     déclenchent ajaxProduct:added avec la réponse de /cart/add. */
  document.addEventListener('ajaxProduct:added', function (event) {
    var data = popData();
    var state = event.detail && event.detail.product;
    if (!data || !state) return;
    var added = state.items || [state];
    var bundleItem = null;
    added.forEach(function (i) {
      if (!bundleItem && data.bundles.indexOf(String(i.product_id)) !== -1) bundleItem = i;
    });
    if (!bundleItem) return;
    /* La fiche produit du duo a déjà son bloc pack : pas de popup en double */
    if (document.querySelector('.mm-up [data-mm-pack]')) return;
    /* Le thème publie cartUpdate (panier à jour) juste avant cet événement,
       puis ouvre son panier latéral : on décide ici, tout de suite. */
    if (lastCart && lastCart.total_price < data.threshold && pickSauces(data, lastCart).length) {
      holdDrawer();
      openPopup(lastCart, bundleItem);
      if (!popup) releaseDrawer(true);
    }
  });

  /* Synchronisation avec le panier du thème */
  function syncCart(cart) {
    lastCart = cart;
    var attrs = cart.attributes || {};
    if (!cart.item_count && (attrs['Upsell pack'] || attrs['Upsell à l’unité'] || attrs['Passage en duo'])) {
      fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { 'Upsell pack': '', 'Upsell à l’unité': '', 'Passage en duo': '' } })
      }).catch(function () {});
    }
    updateBars(cart.total_price);
    markInCart(cart);
  }

  function fetchCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(syncCart)
      .catch(function () {});
  }

  function init() {
    var first = document.querySelector('[data-mm-ship]');
    if (first) updateBars(Number(first.getAttribute('data-total') || 0));
    else updatePacks(0);
    fetchCart();

    if (window.theme && window.theme.pubsub) {
      window.theme.pubsub.subscribe(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (event) {
        var cart = event && event.cart;
        if (!cart) return;
        if (typeof cart.total_price === 'number' && cart.items) syncCart(cart);
        else fetchCart();
      });
      window.theme.pubsub.subscribe(window.theme.pubsub.PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        if (variant && document.querySelector('[data-mm-pack]')) {
          duoVariant = variant;
          updatePacks();
        }
      });
    }
  }

  window.MMUpsell = { sync: fetchCart, add: addToCart, updateBars: updateBars, formatMoney: formatMoney, openPopup: openPopup, closePopup: closePopup };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
